import { apiFetch } from './apiClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export async function logFeatureView(featureArea, page, metadata = {}) {
  try {
    await apiFetch(`${API_BASE_URL}/user-events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event_type: 'feature.view',
        feature_area: featureArea,
        metadata: { page, ...metadata },
      }),
    });
  } catch {
    // Feature-view analytics must never block the page.
  }
}
